<!-- Block user section -->
@if(data.isBlockUSer)
{
<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-2">
    <div class="bg-white rounded-lg shadow-xl p-3 sm:p-4 w-full max-w-sm sm:max-w-md animate-scale-in">
        <div class="flex justify-between items-center mb[8]">
            <h3 class="text-lg font-bold text-gray-900" style="font-weight: 700;">
                {{ 'guard-shift-details.block.title' | translate:{ guardName: data.aliasName ? data.aliasName :
                data.firstName ?
                data.firstName : '-' } }}
            </h3>

            <button class="text-gray-400 hover:text-gray-500 p-1" aria-label="Close" (click)="cancelShift()">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        <div class="mb-3">
            <div class="flex items-center mb-3">
                <div class="bg-red-100 p-[12px] rounded-full mr-[16px] flex-shrink-0" style="margin-top: -16px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-circle-x text-red-600">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M15 9L9 15"></path>
                        <path d="M9 9l6 6"></path>
                    </svg>
                </div>

                <div class="pb-2">
                    <h4 class="text-base sm:text-lg font-medium text-gray-900 mb-0"> {{
                        'guard-shift-details.block.remove_guard' |
                        translate:{ guardName: data.aliasName ? data.aliasName : data.firstName ? data.firstName : '-' }
                        }}</h4>

                    <p class="text-sm text-gray-600">
                        {{ 'guard-shift-details.block.warning' | translate }}
                    </p>
                </div>
            </div>

            <p class="text-sm text-gray-700 mb-8">
                {{ 'guard-shift-details.block.will_do' | translate }}
            </p>
            <ul class="list-disc pl-5 text-sm text-gray-700 mb-3 space-y-1">
                <li>
                    {{ 'guard-shift-details.block.remove_from_shifts' | translate:{ guardName: data.aliasName ?
                    data.aliasName :
                    data.firstName ? data.firstName : '-' } }}
                </li>
                <li>{{ 'guard-shift-details.block.block_from_offers' | translate }}</li>
                <li>{{ 'guard-shift-details.block.irreversible' | translate }}</li>
            </ul>
        </div>

        <div class="flex flex-col sm:flex-row sm:justify-end gap-2">
            <button (click)="cancelShift()"
                class="w-full sm:w-auto px-3 py-1.5 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
                type="button" aria-label="Cancel">
                {{ 'guard-shift-details.block.cancel_button' | translate }}
            </button>
            <button
                class="w-full sm:w-auto px-3 py-1.5 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
                type="button" (click)="blockUser()" aria-label="Confirm">
                {{ 'guard-shift-details.block.confirm_button' | translate }}
            </button>
        </div>
    </div>
</div>
}

<!-- Cancel shift assignment section -->
@else{
<div class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50"
    (click)="onBackdropClick()">
    <div class="bg-white rounded-xl w-full max-w-md p-6 shadow-2xl border border-border/50 animate-scale-in">
        <div class="text-center mb-6">
            <div class="inline-flex items-center justify-center rounded-full bg-destructive/10 mb-4">
                <!-- AlertCircle icon SVG placeholder -->
                <svg xmlns="http://www.w3.org/2000/svg" class="text-destructive" width="28" height="28" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 8v4"></path>
                    <path d="M12 16h.01"></path>
                </svg>
            </div>
            <h3 class="text-lg font-semibold text-foreground mb-2"> {{ 'guard-shift-details.cancel.cancel-shift' |
                translate
                }}</h3>
            <p class="text-sm text-muted-foreground"> {{ 'guard-shift-details.cancel.confirmation-cancel' | translate }}
            </p>
            <div class="mt-[16px] p-[16px] bg-muted/50 rounded-lg text-left border border-border/50 shadow-sm">
                <div class="text-sm">
                    <p class="flex items-center text-red-600">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-circle-alert mr-[4px] text-red-500">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" x2="12" y1="8" y2="12"></line>
                            <line x1="12" x2="12.01" y1="16" y2="16"></line>
                        </svg>
                        50% {{ 'guard-shift-details.cancel.cancel-fee' | translate }}
                    </p>
                    <div class="mt-[8px] space-y-[8px]">
                        <p class="text-xs text-gray-600">
                            {{ 'guard-shift-details.cancel.cancel-message-m1' | translate }}
                        </p>
                        <div
                            class="flex items-start space-x-[8px] p-[8px] bg-blue-50 rounded-md border border-blue-100">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-circle-alert text-blue-600 mt-[2px] flex-shrink-0">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" x2="12" y1="8" y2="12"></line>
                                <line x1="12" x2="12.01" y1="16" y2="16"></line>
                            </svg>
                            <p class="text-xs text-blue-800">
                                {{ 'guard-shift-details.cancel.cancel-message-m2' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-between">
            <button (click)="cancelShift()"
                class="mr-3 px-4 py-2 border border-border rounded-lg text-muted-foreground hover:bg-accent hover:text-foreground transition-colors"
                type="button" aria-label="Keep Shift">
                {{ 'guard-shift-details.cancel.keep-shift' | translate }}
            </button>
            <button (click)="deleteShift()"
                class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors shadow-sm"
                type="button" aria-label="Cancel Shift">
                {{ 'guard-shift-details.cancel.cancel-shift' | translate }}
            </button>
        </div>
    </div>
</div>

}